export default __webpack_public_path__ + "static/media/onjn.f7eaa4ef.png";